var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 31.5337H37.5881C39.2726 31.5337 40.6396 32.8792 40.6396 34.5377V40H14.225V34.5377C14.225 32.8792 15.5919 31.5337 17.2765 31.5337Z",
    fill: "#8F5305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.548038 31.9574L19.0891 13.7058L15.5079 10.1868C14.9174 10.6993 14.0094 10.6743 13.4506 10.1243C12.8664 9.54299 12.8664 8.6116 13.4506 8.03033L21.1718 0.435949C21.756 -0.145316 22.7084 -0.145316 23.2925 0.435949C23.883 1.01103 23.883 1.94861 23.2925 2.52361L23.356 2.4611L33.16 12.1056L33.0965 12.1743C33.6807 11.593 34.6332 11.593 35.2173 12.1743C35.8078 12.7494 35.8078 13.687 35.2173 14.2621L27.5024 21.8626C26.9119 22.4377 25.9595 22.4377 25.3753 21.8626C24.7911 21.2814 24.7911 20.35 25.3753 19.7689L25.3118 19.8312L21.7306 16.3122L3.19588 34.5575C2.46567 35.2763 1.27825 35.2763 0.548038 34.5575C-0.182175 33.8387 -0.182175 32.6761 0.548038 31.9574Z",
    fill: "#8F5305"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/law.8417b1e932656802fb5fe64172dcc26f.svg";
export { ForwardRef as ReactComponent };